import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class ReporteAuditoriaModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      usuario : undefined
      , modulo : undefined
      , fecha : undefined
      , fecha_inicio: dateMethods.getDate()
      , fecha_fin: dateMethods.getDate()
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      usuario:usuario=>usuario
      , modulo:modulo=>modulo
      , fecha:fecha=>fecha
      , fecha_inicio:fecha_inicio=>fecha_inicio
      , fecha_fin:fecha_fin=>fecha_fin
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/bitacoras/reporte-auditoria.js